import { FC, useContext, useEffect } from "react";
import { useParams } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { FirestoreContext } from "../../context/Context";
import { NotFound } from "../../components";
import { ArticleContainer, TitleContainer, Content } from "./styles";

const ArticlePage: FC = () => {
  const data = useContext(FirestoreContext);
  const { id } = useParams();
  let targetArticle = data.articles.find((element) => element.id === id);

  useEffect(() => {
    const originalBg = document.body.style.backgroundColor;
    document.body.style.backgroundColor = "#f9f9f9";
    return () => {
      document.body.style.backgroundColor = originalBg;
    };
  }, []);

  window.scrollTo(0, 0);

  return targetArticle ? (
    <>
      <Helmet>
        <title>{targetArticle.title} | Truth Miner</title>
        <meta name="description" content={targetArticle.description} />
      </Helmet>
      <ArticleContainer>
        <TitleContainer> {targetArticle.title} </TitleContainer>
        <Content dangerouslySetInnerHTML={{ __html: targetArticle.content }} />
      </ArticleContainer>
    </>
  ) : (
    <NotFound />
  );
};

export default ArticlePage;
